<template>
  <b-modal
    id="mobilepay-redirect-modal"
    hide-footer
    centered
    no-close-on-backdrop
    content-class="rounded-modal"
    hide-header-close
    size="xl"
  >
    <div class="row">
      <div class="col-12 text-center p-3 p-sm-4 p-md-4">
        <i class="icon icon-mobilePay--vertical"></i>
      </div>
    </div>
    <div role="alert" class="row">
      <div
        class="col-12 p-3 p-sm-4 p-md-4 text-lg text-center"
        v-html="countdownText"
      ></div>
    </div>
  </b-modal>
</template>

<script>
  export default {
    props: {
      countdownText: String,
    },
  };
</script>

<style lang="scss" scoped>
  @media (min-width: 1200px) {
    ::v-deep .modal-xl {
      max-width: 1050px;
    }
  }

  ::v-deep .rounded-modal {
    border-radius: 8px;
  }

  ::v-deep .modal-content {
    height: 25rem;
  }

  .text-lg {
    font-size: $font-size-lg;
    color: $blue;
    font-family: 'Melior';
    font-size: 24px;
    letter-spacing: -0.14px;
    line-height: 36px;
  }
</style>
